"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _repeatInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/repeat");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.registerVirtualizedTree = exports.BmTreeVirtualized = void 0;

var _every = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/every"));

var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _element = require("@blue/element");

var _bmTreeItem = require("./bm-tree-item");

var _bmTreeDropArea = require("./bm-tree-drop-area");

var _bmTree = require("./bm-tree");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t\t\t<div class=\"top-padding\"></div>\n\t\t\t", "\n\t\t\t<div class=\"bottom-padding\"></div>\n\t\t"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n\t:host {\n\t\t--theme-color: #ff8000;\n\t\t--background-color: #f4f5f7;\n\t\t--bm-tree-item-height: 30px;\n\t\t--bm-tree-item-width: auto;\n\t\t--bm-tree-item-font-size: 16px;\n\t\t--bm-tree-item-border;\n\t\t--bm-tree-height: inherit;\n\t\t--bm-tree-width: inherit;\n\t\t--bm-tree-item-padding-right: 7px;\n\t\t--bm-tree-item-text-decoration: none;\n\t\t--bm-tree-item-color: black;\n\t\theight: inherit;\n\t\theight: var(--bm-tree-height, inherit);\n\t\twidth: inherit;\n\t\twidth: var(--bm-tree-width, inherit);\n\t\tdisplay: block;\n\t}\n\t:host .hidden {\n\t\tdisplay: none;\n\t}\n\t:host .drop-area {\n\t\theight: 2px;\n\t}\n\t:host .drop-area.drag-over {\n\t\tbackground: #b2b2b8;\n\t}\n\t:host .top-padding {\n\t\theight: var(--vs-top-height);\n\t}\n\t:host .bottom-padding {\n\t\theight: var(--vs-bottom-height);\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var style = (0, _element.css)(_templateObject());

var BmTreeVirtualized = /*#__PURE__*/function (_BmTree) {
  (0, _inherits2.default)(BmTreeVirtualized, _BmTree);

  var _super = (0, _createSuper2.default)(BmTreeVirtualized);

  (0, _createClass2.default)(BmTreeVirtualized, null, [{
    key: "is",
    get: function get() {
      return 'bm-tree-virtualized';
    }
  }, {
    key: "properties",
    get: function get() {
      return (0, _objectSpread2.default)({}, (0, _get2.default)((0, _getPrototypeOf2.default)(BmTreeVirtualized), "properties", this));
    }
  }, {
    key: "styles",
    get: function get() {
      return style;
    }
  }]);

  function BmTreeVirtualized() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmTreeVirtualized);
    _this = _super.call(this);
    _this.itemHeight = void 0;
    _this.scrollTarget = void 0;
    _this.startingIndex = void 0;
    _this.scrollTicking = void 0;
    _this.onScroll = (0, _bind.default)(_context = _this.onScroll).call(_context, (0, _assertThisInitialized2.default)(_this));
    _this.scrollTicking = null;
    _this.startingIndex = 0;
    _this.itemHeight = 30;
    return _this;
  }

  (0, _createClass2.default)(BmTreeVirtualized, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$scrollTarget;

      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTreeVirtualized.prototype), "connectedCallback", this).call(this);
      this.scrollTarget = this.getScrollableParent(this);
      (_this$scrollTarget = this.scrollTarget) === null || _this$scrollTarget === void 0 ? void 0 : _this$scrollTarget.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$scrollTarget2;

      (0, _get2.default)((0, _getPrototypeOf2.default)(BmTreeVirtualized.prototype), "disconnectedCallback", this).call(this);
      (_this$scrollTarget2 = this.scrollTarget) === null || _this$scrollTarget2 === void 0 ? void 0 : _this$scrollTarget2.removeEventListener('scroll', this.onScroll);
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var _this2 = this;

      if (this.scrollTicking) {
        window.cancelAnimationFrame(this.scrollTicking);
        this.scrollTicking = null;
      }

      this.scrollTicking = window.requestAnimationFrame(function () {
        if (_this2.scrollTarget) {
          var _this2$scrollTarget$g;

          var scrollStartPos = Math.max(0, Math.min(((_this2$scrollTarget$g = _this2.scrollTarget.getBoundingClientRect()) === null || _this2$scrollTarget$g === void 0 ? void 0 : _this2$scrollTarget$g.top) - _this2.getBoundingClientRect().top));
          var scrollPosByItemHeight = scrollStartPos / _this2.itemHeight;
          var isShowingWholeItem = scrollPosByItemHeight % 1 < 0.45 || scrollPosByItemHeight % 1 > 0.55;

          if (isShowingWholeItem) {
            _this2.startingIndex = Math.round(scrollPosByItemHeight);

            _this2.handleStateChange();
          }
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$scrollTarget$ge, _this$scrollTarget3, _this$scrollTarget3$g, _context2, _this$store$getAll, _this$store;

      var visiblePartHeight = (_this$scrollTarget$ge = (_this$scrollTarget3 = this.scrollTarget) === null || _this$scrollTarget3 === void 0 ? void 0 : (_this$scrollTarget3$g = _this$scrollTarget3.getBoundingClientRect()) === null || _this$scrollTarget3$g === void 0 ? void 0 : _this$scrollTarget3$g.height) !== null && _this$scrollTarget$ge !== void 0 ? _this$scrollTarget$ge : 0;
      var visibleItems = (0, _filter.default)(_context2 = (_this$store$getAll = (_this$store = this.store) === null || _this$store === void 0 ? void 0 : _this$store.getAll()) !== null && _this$store$getAll !== void 0 ? _this$store$getAll : []).call(_context2, function (e) {
        return e.visible;
      });
      var visibleItemsCapacity = Math.round(visiblePartHeight / this.itemHeight);
      var tolerance = 2;
      var listSize = Math.min(Math.max(visibleItemsCapacity + tolerance, 0), visibleItems.length);
      var itemsToRender = (0, _slice.default)(visibleItems).call(visibleItems, this.startingIndex, this.startingIndex + listSize);
      var topPadding = this.startingIndex * this.itemHeight;
      var bottomPadding = (visibleItems.length - listSize - this.startingIndex) * this.itemHeight;
      this.style.setProperty('--vs-top-height', "".concat(topPadding, "px"));
      this.style.setProperty('--vs-bottom-height', "".concat(bottomPadding, "px"));
      var template = (0, _element.html)(_templateObject2(), (0, _repeatInstanceProperty(_element))(itemsToRender, function (item) {
        return item.id;
      }, this.renderTreeItem));
      return template;
    }
  }, {
    key: "getScrollableParent",
    value: function getScrollableParent(node) {
      var parentElement = this.getParentElement(node);

      if (!parentElement) {
        return null;
      }

      var isScrollable = this.isScrollableElement(parentElement);

      if (isScrollable) {
        return node;
      }

      return this.getScrollableParent(parentElement.parentElement);
    }
  }, {
    key: "getParentElement",
    value: function getParentElement(node) {
      var _node$defaultView, _node$defaultView$fra;

      if (!node) {
        return null;
      }

      if (node instanceof ShadowRoot && (node === null || node === void 0 ? void 0 : node.host) instanceof Element) {
        return node.host;
      }

      if (node instanceof Document && ((_node$defaultView = node.defaultView) === null || _node$defaultView === void 0 ? void 0 : (_node$defaultView$fra = _node$defaultView.frameElement) === null || _node$defaultView$fra === void 0 ? void 0 : _node$defaultView$fra.parentNode)) {
        return node.defaultView.frameElement.parentNode;
      }

      return node;
    }
  }, {
    key: "isScrollableElement",
    value: function isScrollableElement(element) {
      var _context3;

      var overflowYStyle = window.getComputedStyle(element).overflowY;
      var isOverflowScrollable = (0, _every.default)(_context3 = overflowYStyle.split(' ')).call(_context3, function (o) {
        return o === 'auto' || o === 'scroll';
      });
      return isOverflowScrollable;
    }
  }]);
  return BmTreeVirtualized;
}(_bmTree.BmTree);

exports.BmTreeVirtualized = BmTreeVirtualized;

var registerVirtualizedTree = function registerVirtualizedTree() {
  (0, _bmTreeItem.registerTreeItem)();
  (0, _bmTreeDropArea.registerTreeDropArea)();
  (0, _element.register)(BmTreeVirtualized);
};

exports.registerVirtualizedTree = registerVirtualizedTree;
